// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as TraitName0 from "common/src/tft-static/TraitName0.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";

function SupUnitCard(Props) {
  var unitId = Props.unitId;
  var traits = Props.traits;
  var wOpt = Props.width;
  var widthSmOpt = Props.widthSm;
  var widthMdOpt = Props.widthMd;
  var widthXlOpt = Props.widthXl;
  var w = wOpt !== undefined ? wOpt : 220;
  var widthSm = widthSmOpt !== undefined ? widthSmOpt : w;
  var widthMd = widthMdOpt !== undefined ? widthMdOpt : widthSm;
  var widthXl = widthXlOpt !== undefined ? widthXlOpt : widthMd;
  var basePath3 = CdnAtom.usePath4(undefined);
  var unitsT = Translation.useT(/* Units */1);
  Translation.useT(/* Traits */2);
  var set = TftSet.use(undefined);
  var src = set === 180 ? basePath3 + "/gg17/face_full_ultrawide/" + unitId + ".jpg?w=" + String(widthXl) : (
      set === 170 ? basePath3 + "/new17/face_full_ultrawide/" + unitId + ".jpg?w=" + String(widthXl) : (
          set === 160 ? basePath3 + "/face_full_ultrawide/" + unitId + ".jpg?w=" + String(widthXl) : (
              set === 140 ? basePath3 + "/cd14/face_full_ultrawide/" + unitId + ".jpg?w=" + String(widthXl) : (
                  set === 150 ? basePath3 + "/dc15/face_full_ultrawide/" + unitId + ".jpg?w=" + String(widthXl) : (
                      set === 130 ? basePath3 + "/ts13/face_full_ultrawide/" + unitId + ".jpg?w=" + String(widthXl) : basePath3 + "/face_full_ultrawide/" + unitId + ".jpg?w=" + String(widthXl)
                    )
                )
            )
        )
    );
  return React.createElement("div", {
              key: unitId,
              className: "relative rounded-[6px] border-[3px] border-primary-6"
            }, React.createElement("div", {
                  className: CssJs.merge([
                        "relative flex justify-between p-[9px] bg-bg text-[18px] font-montserrat font-semibold rounded-[3px]",
                        CssJs.style([CssJs.borderBottom(CssJs.px(3), CssJs.solid, CssJs.hex(Sd.tierColor(Sd.unitTier(unitId))))])
                      ])
                }, unitsT(unitId), React.createElement("div", {
                      className: "flex items-end text-[16px]"
                    }, String(Sd.unitCost(unitId, set)), React.createElement("img", {
                          className: "ml-[2px] pb-[1px]",
                          alt: "gold",
                          height: "13",
                          src: basePath3 + "/general/gold.png?w=13",
                          width: "13"
                        }))), React.createElement("img", {
                  className: CssJs.merge([
                        "mt-[-3px] z-[-1] aspect-[9/4] object-cover",
                        CssJs.style([
                              CssJs.width(CssJs.px(w)),
                              T.sm_([CssJs.width(CssJs.px(widthSm))]),
                              T.sm_([CssJs.width(CssJs.px(widthSm))]),
                              T.md_([CssJs.width(CssJs.px(widthMd))]),
                              T.xl_([CssJs.width(CssJs.px(widthXl))])
                            ])
                      ]),
                  alt: unitsT(unitId),
                  src: src,
                  width: String(widthXl)
                }), React.createElement("div", {
                  className: "absolute text-lg leading-snug bottom-[6px] left-[6px]"
                }, Belt_Array.map(traits, (function (trait) {
                        return React.createElement("div", {
                                    key: trait,
                                    className: "flex items-center sm:pt-1 font-montserrat font-bold text-[15px]"
                                  }, React.createElement(TraitTooltip.make, {
                                        trait: trait,
                                        children: React.createElement(TraitImage.PlainIcon.make, {
                                              traitId: trait,
                                              size: 21
                                            })
                                      }), React.createElement("div", {
                                        className: CssJs.merge([
                                              "pl-1",
                                              CssJs.style([CssJs.unsafe("textShadow", "-1px 0 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 1px 0 5px rgba(0, 0, 0, 0.3), 0 -1px 5px rgba(0, 0, 0, 0.3)")])
                                            ])
                                      }, React.createElement(TraitName0.make, {
                                            trait: trait
                                          })));
                      }))));
}

var make = SupUnitCard;

export {
  make ,
  
}
/* T Not a pure module */
